<table *ngIf="groupResults && groupResults.length>0" class="display my-table table-bordered " BORDER=0 CELLSPACING=0 attr.style="margin-right:1%; float:left; width:{{period.tableWidth}}%; border-spacing: 0; border-collapse: collapse;">
                <thead>
                    <tr style="height:10px;" attr.style="font-size:{{period.headTableTextsize}}px">
                        <th *ngIf="period.showId">#</th>
                        <th>{{period?.tmat}}</th>
                        <th>{{ period?.tcoef }}</th>
                        <th>{{ period?.tnote }}</th>
                        <th *ngIf="period.tools">Calculable</th>
                    </tr>
                </thead>
                <tbody *ngFor="let g of groupResults; let j = index">


                    <tr  attr.style="height: auto; padding:none; font-size:{{period.text_cat }}px;">
                        <td *ngIf="period.showId">{{ g?.code}} </td>
                        <td>
                            <b> {{ g?.categorie?.name}}</b>
                        </td>
                        <td class="note-td" title="coef" >
                             <b>{{ g?.total_note }}</b>
                        </td>
                        <td class="note-td"  title="note">

                        </td>
                        <td class="note-td" *ngIf="period.tools && g.categorie" >
                            <input type="checkbox" [(ngModel)]="g.categorie.is_calc" >
                        </td>
                    </tr>
                     <tr *ngFor="let o of g.results ; let i = index" attr.style="height: auto; padding:none; font-size:{{period.text_cours}}px;">
                        <td *ngIf="period.showId"> {{ o?.cours?.code}} </td>
                        <td>
                             {{ "   "+o?.cours?.name}}
                        </td>
                        <td class="note-td">
                            {{ o?.cours?.note_total }}
                        </td>
                        <td class="note-td" *ngIf="o.is_calc">
                            {{ (o?.note) ? parseInt(o?.note) : '' }}
                        </td>
                        <td class="note-td" *ngIf="!o.is_calc">-</td>
                        <td class="note-td" *ngIf="period.tools">
                            <input type="checkbox" [(ngModel)]="o.is_calc">
                        </td>
                    </tr>
                     <tr  attr.style="height: auto; padding:none; font-size:{{period.text_cat }};">
                        <td *ngIf="period.showId">  </td>
                        <td>

                        </td>
                        <td class="note-td">
                          <b>Total</b>
                        </td>
                        <td class="note-td" >
                            {{ (g?.note) ? g?.note : '' }} / <b>{{ g?.total_note }}</b>
                        </td>
                        <td class="note-td" *ngIf="period.tools && g.categorie" >
                            <input type="checkbox" [(ngModel)]="g.categorie.is_calc" >
                        </td>
                    </tr>

                </tbody>
</table>
